import { RootState } from 'Data/Redux';
import { createSelector } from 'reselect';

const headerSelector = (state: RootState) => state.worksheetEditor.syncModel?.header;
const idSelector = (state: RootState) => state.worksheetEditor.syncModel?.type?.Id;
const userClaimsSelector = (state: RootState) => state.user.data?.Claims;

const claimSelector = createSelector(userClaimsSelector, idSelector, (claims, id) => {
  const { 'sq.worksheets.edit': worksheetsEditableClaim } = claims;
  // Lock all fields on worksheet if they do not have "edit" claim for worksheet in question
  const editableWorksheetTypeIds = worksheetsEditableClaim ? worksheetsEditableClaim.split(',') : [];
  if (!editableWorksheetTypeIds.includes(id)) {
    return true;
  }
});

const signedReportSelector = createSelector(headerSelector, (header) => {
  if (header.IsOnSignedReport) {
    return true;
  }
});

export const readOnlyCheckedSelector = createSelector(headerSelector, (header) => {
  return !!header.IsChecked;
});

export const deletingSelector = createSelector(headerSelector, (header) => {
  return !!header.deleting;
});

const completedAtDifferentLabSelector = createSelector(headerSelector, (header) => {
  return !!header.CompletedAtDifferentLab;
});

export const readOnlySelector = createSelector(
  claimSelector,
  signedReportSelector,
  readOnlyCheckedSelector,
  deletingSelector,
  completedAtDifferentLabSelector,
  (missingClaim, signedReport, checked, deleting, completedAtDifferentLab) => {
    return missingClaim || signedReport || checked || deleting || completedAtDifferentLab;
  }
);
